import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./contexts/authContext";
import { PrestaFncProvider } from "./contexts/prestaFncContext";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <PrestaFncProvider>
          <App />
        </PrestaFncProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// ReactDOM.render(
//   <AuthProvider>
//     <PrestaFncProvider>
//     <App />
//     </PrestaFncProvider>
//   </AuthProvider>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
